module.exports = __webpack_public_path__ + "img/traksi_logo.fba59cbc.png";